import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0.5h2.5v0.5h-2.5z' },
    {
      paint: 'tulipStem',
      d: 'M0,-2h0.5v0.5h-0.5zM-2,-1.5h0.5v0.5h-0.5zM-0.5,-1.5h1v0.5h-1zM-2,-1h1v1h-1zM-0.5,-1h2.5v0.5h-2.5zM0,-0.5h0.5v0.5h-0.5zM1.5,-0.5h1.5v0.5h-1.5zM-2,0h0.5v1h-0.5zM-0.5,0h1v0.5h-1zM1.5,0h1v0.5h-1zM1.5,0.5h0.5v1h-0.5z',
    },
    {
      paint: 'sproutGreen',
      d: 'M-1.5,-1.5h1v0.5h-1zM-3,-1h1v0.5h-1zM-1,-1h0.5v0.5h-0.5zM-2.5,-0.5h0.5v1h-0.5zM-1,-0.5h1v0.5h-1zM0.5,-0.5h1v1h-1zM1,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'tulipRed', d: 'M-2.5,-2.5h1.5v0.5h-1.5zM-2.5,-2h1v0.5h-1z' },
    {
      paint: [
        ['cherryTrunk', 0.23],
        ['tulipRed', 0.77],
      ],
      d: 'M-1.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'tulipYellow', d: 'M-1,-3h0.5v0.5h-0.5zM0,-3h0.5v0.5h-0.5zM-1,-2.5h1.5v0.5h-1.5z' },
    {
      paint: [
        ['cherryTrunk', 0.23],
        ['tulipYellow', 0.77],
      ],
      d: 'M0.5,-3h0.5v1h-0.5zM-0.5,-2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['eggWhite', 0.38],
        ['tulipYellow', 0.62],
      ],
      d: 'M-0.5,-3h0.5v0.5h-0.5z',
    },
    { paint: 'tulipPurple', d: 'M1.5,-2.5h1v0.5h-1zM1,-2h1v1h-1z' },
    {
      paint: [
        ['cherryTrunk', 0.23],
        ['tulipPurple', 0.77],
      ],
      d: 'M2,-2h0.5v1h-0.5z',
    },
  ],
  pixels: 67,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-2,0.5h1v0.5h-1zM-0.5,0.5h1v0.5h-1zM1.5,0.5h0.5v0.5h-0.5zM0.5,1h1v0.5h-1z',
    },
    {
      paint: 'tulipStem',
      d: 'M-2.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v0.5h-0.5zM-2.5,-1h2v0.5h-2zM0.5,-1h1v0.5h-1zM2,-1h1.5v0.5h-1.5zM-2.5,-0.5h1v0.5h-1zM-1,-0.5h1v1h-1zM0.5,-0.5h1.5v0.5h-1.5zM2.5,-0.5h0.5v0.5h-0.5zM-2.5,0h0.5v0.5h-0.5zM1,0h1.5v0.5h-1.5zM-1,0.5h0.5v1h-0.5zM0.5,0.5h1v0.5h-1z',
    },
    {
      paint: 'sproutGreen',
      d: 'M-3,-1h0.5v1h-0.5zM1.5,-1h0.5v0.5h-0.5zM-1.5,-0.5h0.5v1h-0.5zM0,-0.5h0.5v0.5h-0.5zM2,-0.5h0.5v0.5h-0.5zM0,0h1v0.5h-1z',
    },
    {
      paint: 'tulipRed',
      d: 'M-3,-2.5h1.5v0.5h-1.5zM-1,-2.5h0.5v0.5h-0.5zM1,-2.5h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM-3,-2h1v0.5h-1zM-1.5,-2h1v1h-1zM0,-2h1.5v1h-1.5zM2,-2h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['cherryTrunk', 0.23],
        ['tulipRed', 0.77],
      ],
      d: 'M-2,-2h0.5v0.5h-0.5zM-0.5,-2h0.5v1h-0.5zM1.5,-2h0.5v1h-0.5zM2.5,-2h0.5v0.5h-0.5z',
    },
  ],
  pixels: 71,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M1.5,0.5h0.5v0.5h-0.5z' },
    {
      paint: 'tulipStem',
      d: 'M-2,-1.5h1.5v0.5h-1.5zM0.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h1v0.5h-1zM-3,-1h1v1h-1zM-1.5,-1h1.5v1h-1.5zM0.5,-1h2.5v0.5h-2.5zM0.5,-0.5h2v0.5h-2zM-3,0h3v0.5h-3zM0.5,0h1.5v0.5h-1.5zM-2.5,0.5h4v0.5h-4zM0.5,1h1v0.5h-1z',
    },
    { paint: 'sproutGreen', d: 'M-2,-1h0.5v1h-0.5zM0,-1h0.5v1.5h-0.5z' },
    { paint: 'tulipYellow', d: 'M-1.5,-3h1v0.5h-1zM-2,-2.5h1.5v0.5h-1.5zM-2,-2h1v0.5h-1z' },
    {
      paint: [
        ['cherryTrunk', 0.23],
        ['tulipYellow', 0.77],
      ],
      d: 'M-0.5,-2.5h0.5v0.5h-0.5zM-1,-2h1v0.5h-1z',
    },
    { paint: 'tulipPurple', d: 'M0.5,-3h1.5v0.5h-1.5zM0.5,-2.5h1v1h-1z' },
    {
      paint: [
        ['cherryTrunk', 0.23],
        ['tulipPurple', 0.77],
      ],
      d: 'M1.5,-2.5h0.5v1h-0.5zM1,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['eggWhite', 0.38],
        ['tulipPurple', 0.62],
      ],
      d: 'M0,-2.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 71,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
